import axios, { endpoints } from 'src/utils/axios';
import { custom } from 'zod';

// ADD PROGRAM
export const AddProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.program.add_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// EDIT PROGRAM
export const EditProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.program.edit_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET PROGRAMS
export const get_programs = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_programs}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// GET TRAINER PROGRAMS FOR MEMBERS
export const get_trainer_programs_for_members = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(
      `${endpoints.program.get_trainer_programs_for_members}${queryParams}`
    );
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// GET PROGRAM MEMBERS
export const get_program_members = async ({ id, search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_program_members}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE PROGRAM
export const delete_program = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);

    const res = await axios.post(endpoints.program.delete_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error delete request:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// DELETE PARENT PROGRAM
export const delete_parent_program = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.delete_parent_program}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

export const delete_program_final = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('request_id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.delete_program_final}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// RELEASE PROGRAM

export const release_program = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.release_program}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

export const reject_delete_request = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('request_id', id);

    const res = await axios.post(endpoints.program.reject_delete_request, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error delete request:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAMS
export const get_personal_member = async () => {
  try {
    const res = await axios.get(endpoints.program.get_personal_member);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ASSIGN MEMBERS TO PROGRAM
export const assign_members_to_program = async ({ original_id, program_id, member_ids }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    member_ids && formData.append('member_ids', member_ids.join(','));
    const res = await axios.post(endpoints.program.assign_members_to_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// SEND REQUEST TO MEMBERS
export const send_request_to_members = async ({ original_id, program_id, member_ids }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    member_ids && formData.append('member_ids', member_ids.join(','));
    const res = await axios.post(endpoints.program.send_request_to_members, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// SEND CHANGES FOR APPROVAL
export const send_changes_for_approval = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line

    program_id && formData.append('program_id', program_id);

    const res = await axios.post(endpoints.program.send_changes_for_approval, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// ADD NOTES TO PROGRAM
export const add_note_to_program = async ({ program_id, notes }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_trail_id', program_id);
    notes && formData.append('message', notes);

    const res = await axios.post(endpoints.program.add_note_to_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// SEND CHANGES REQUEST TO TRAINER
export const send_change_request_to_trainer = async ({ program_id, notes }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_trail_id', program_id);
    notes && formData.append('message', notes);

    const res = await axios.post(endpoints.program.send_change_request_to_trainer, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// APPROVE REQUEST
export const mark_as_approve = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('id', program_id);

    const res = await axios.post(endpoints.program.mark_as_approve, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};
// UNASSIGN MEMBERS TO PROGRAM
export const unassign_members_to_program = async ({ original_id, program_id, member_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    member_id && formData.append('member_id', member_id);
    const res = await axios.post(endpoints.program.unassign_members_to_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAM DETAILS
export const get_program_detail = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_program_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM DETAILS BY MEMBER
export const get_program_detail_by_member = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_program_details_by_member}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE PROGRAM
export const delete_week = async ({ id, original_id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    if (original_id) params.append('original_id', original_id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.delete_week}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// ASSIGN MEMBERS TO PROGRAM
export const mark_as_active = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('id', program_id);

    const res = await axios.post(endpoints.program.mark_as_active, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

/** ADD COMMENT  */

export const AddCommentMedia = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const AddComment = async ({ parent_id, exercise_id, comment, comment_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    exercise_id && formData.append('exercise_id', exercise_id);
    parent_id && formData.append('parent_id', parent_id);

    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAMS
export const get_comments_by_id = async ({ exercise_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (exercise_id) {
      const params = new URLSearchParams();
      if (exercise_id) params.append('exercise_id', exercise_id);
      if (activity_id) params.append('activity_id', activity_id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_comments_by_id}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// TRAINERS FOR PERSONAL MEMBER

// GET PROGRAMS
export const get_trainers_for_pm = async () => {
  try {
    const res = await axios.get(endpoints.program.get_trainers_personal_member);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ASSIGN MEMBERS TO PROGRAM
export const assign_trainer_to_program = async ({ original_id, program_id, trainer_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    trainer_id && formData.append('trainer_id', trainer_id);
    const res = await axios.post(endpoints.program.assign_trainer_to_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// UNASSIGN MEMBERS TO PROGRAM
export const unassign_trainer_from_program = async ({ original_id, program_id, trainer_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    trainer_id && formData.append('trainer_id', trainer_id);
    const res = await axios.post(endpoints.program.unassign_trainer_to_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAMS
export const get_my_programs = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_my_programs}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

/** ADD COMMENT  */

export const AddCommentMedia_set = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment_media_set, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const AddComment_set = async ({ parent_id, set_id, comment, comment_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    set_id && formData.append('set_id', set_id);
    parent_id && formData.append('parent_id', parent_id);
    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment_set, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAMS
export const get_comments_by_id_set = async ({ set_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (set_id) {
      const params = new URLSearchParams();
      if (set_id) params.append('set_id', set_id);
      if (activity_id) params.append('activity_id', activity_id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_comments_by_id_set}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// MARK AS COMPLETE
export const mark_as_complete_exercise = async ({ id, program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    program_id && formData.append('program_trail_id', program_id);

    const res = await axios.post(endpoints.program.mark_as_complete_exercise, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

export const mark_as_complete_set = async ({ id, program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    program_id && formData.append('program_trail_id', program_id);

    const res = await axios.post(endpoints.program.mark_as_complete_set, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// ADD PROGRAM
export const AddPlateProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.program.add_plate_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// EDIT PROGRAM
export const EditPlateProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.program.edit_plate_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET PROGRAMS
export const get_plate_programs = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_plate_programs}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM BY ID
export const get_plate_program_details = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_plate_program_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// SEND REQUEST TO MEMBERS
export const send_request_to_member_plates = async ({ original_id, program_id, member_ids }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    original_id && formData.append('original_id', original_id);
    program_id && formData.append('program_id', program_id);
    member_ids && formData.append('member_ids', member_ids.join(','));
    const res = await axios.post(endpoints.program.send_request_to_member_plates, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET TRAINER PLATES FOR MEMBERS
export const get_trainer_plates_for_member = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_trainer_plates_for_member}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD NOTES TO PROGRAM
export const add_note_to_plate = async ({ program_id, notes }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_trail_id', program_id);
    notes && formData.append('message', notes);

    const res = await axios.post(endpoints.program.add_note_to_plate, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAM DETAILS BY MEMBER
export const get_plate_detail_by_member = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_plate_detail_by_member}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM DETAILS
export const get_plate_detail = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_program_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// APPROVE REQUEST
export const mark_as_approve_plate = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('id', program_id);

    const res = await axios.post(endpoints.program.mark_as_approve_plate, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// SEND CHANGES REQUEST TO TRAINER
export const send_change_request_to_trainer_plate = async ({ program_id, notes }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_trail_id', program_id);
    notes && formData.append('message', notes);

    const res = await axios.post(endpoints.program.send_change_request_to_trainer_plate, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding note:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAM MEMBERS
export const get_plate_members = async ({ id, search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_plate_members}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// SEND CHANGES FOR APPROVAL
export const send_changes_for_approval_plate = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line

    program_id && formData.append('program_id', program_id);

    const res = await axios.post(endpoints.program.send_changes_for_approval_plate, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// MARK ACTIVE PLATE
export const mark_as_active_plate = async ({ program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('id', program_id);

    const res = await axios.post(endpoints.program.mark_as_active_plate, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};
// DELETE WEEK PLATE PROGRAM
export const delete_week_plate = async ({ id, original_id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    if (original_id) params.append('original_id', original_id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.delete_week_plate}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAMS
export const get_my_programs_plate = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_my_programs_plate}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET FOOD ITEMS
export const get_food_items = async () => {
  try {
    // Build query params conditionally

    const res = await axios.get(`${endpoints.program.get_food_items}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET DISH ITEMS
export const get_dish_items = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_dish_items}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET UNITS
export const get_units = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_units}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET UNITS FOR DROPDOWN
export const get_units_for_dropdown = async (food_id) => {
  try {
    const res = await axios.get(`${endpoints.program.get_units}?food_id=${food_id}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_units_with_nutrients = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_units_with_nutrients}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_nutrition_dropdown = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_nutrition_dropdown}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting nutrition:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// submit_food_log
export const Submit_food_log = async ({ foodLogData }) => {
  try {
    const res = await axios.post(
      endpoints.program.submit_food_log,
      foodLogData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET UNITS
export const get_day_nutritions = async (day_id) => {
  try {
    const res = await axios.get(`${endpoints.program.get_day_nutritions}?day_id=${day_id}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_day_all_nutrients = async (day_id) => {
  try {
    const res = await axios.get(`${endpoints.program.get_day_all_nutrients}?day_id=${day_id}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE FOOD LOGs
export const delete_food_log = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('log_id', id);
    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.program.delete_food_log}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET PROGRAM FOR DROPDOWN
export const get_program_for_dropdown = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_programs_for_dropdown}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM PROGRESS
export const get_program_progress = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('program_id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_program_progress}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET Plate FOR DROPDOWN
export const get_plates_for_dropdown = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_plates_for_dropdown}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM PROGRESS
export const get_plate_progress = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('program_id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_plate_progress}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD PROGRAM
export const add_new_food_item = async (foodData) => {
  try {
    const res = await axios.post(
      endpoints.program.add_food_item,
      foodData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

export const add_new_dish = async (dishData) => {
  try {
    const res = await axios.post(
      endpoints.program.add_dish_item,
      dishData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

/** SET DISCUSSION  */

export const AddCommentMedia_log = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment_media_log, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const AddComment_log = async ({ parent_id, log_id, comment, comment_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    log_id && formData.append('member_day_food_dish_id', log_id);
    parent_id && formData.append('parent_id', parent_id);

    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_comment_log, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_comments_by_id_log = async ({ log_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (log_id) {
      const params = new URLSearchParams();
      if (log_id) params.append('member_day_food_dish_id', log_id);
      if (activity_id) params.append('activity_id', activity_id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_comments_by_id_log}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// LIBRARY HIGHLIGHTS

export const get_library_highlights = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_library_highlights}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// PROGRESS NOTES

export const add_progress_media = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_progress_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const add_progress_note = async ({ comment, notes_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object

    comment && formData.append('comment', comment);
    notes_media_ids && formData.append('notes_media_ids', notes_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_progress_note, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_progress_notes = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_progress_notes}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// CUSTOM GOALS

// GET CUSTOM GOAL CATEGORY
export const get_custom_goal_category = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_custom_goal_category}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// GET CUSTOM GOAL UNIT
export const get_custom_goal_units = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_custom_goal_units}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// GET CUSTOM GOALS
export const get_custom_goals = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_custom_goals}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// ADD CUSTOM GOAL
export const add_custom_goal = async (goalData) => {
  try {
    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_custom_goal, goalData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
// GET CUSTOM GOAL DETAILS
export const get_custom_goal_detail = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_custom_goal_detail}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GOAL ENTRIES

export const AddEntryMedia = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.upload_milestone_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding media:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const add_goal_entry = async (data) => {
  try {
    const { custom_goal_id, title, notes, entry_type, media_ids, custom_goal_milestone_id, value } =
      data;
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    custom_goal_id && formData.append('custom_goal_id', custom_goal_id);

    title && formData.append('title', title);
    notes && formData.append('notes', notes);
    entry_type && formData.append('entry_type', entry_type);
    media_ids && formData.append('media_ids', media_ids);
    custom_goal_milestone_id &&
      formData.append('custom_goal_milestone_id', custom_goal_milestone_id);
    value && formData.append('value', value);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.program?.add_custom_goal_entry, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_goal_entries = async ({ goal_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (goal_id) {
      const params = new URLSearchParams();
      if (goal_id) params.append('custom_goal_id', goal_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.program.get_custom_goal_entries}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET RECENT ACHIEVEMENTS
export const get_recents_achievements = async () => {
  try {
    // Build query params conditionally
    const res = await axios.get(`${endpoints.program.get_recent_achievements}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_quick_notes = async () => {
  try {
    // Build query params conditionally
    const res = await axios.get(`${endpoints.program.get_quick_notes}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// SETTINGS DASHBOARD

export const get_dashboard_setting = async () => {
  try {
    // Build query params conditionally
    const res = await axios.get(`${endpoints.program.get_dashboard_setting}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting settings:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const set_train_streak = async ({ train_streak_type }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (train_streak_type) params.append('train_streak_type', train_streak_type);

    queryParams = `?${params.toString()}`;
    const res = await axios.post(`${endpoints.program.set_train_streak}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during save setting:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

export const set_plate_streak = async ({ plate_streak_type }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (plate_streak_type) params.append('plate_streak_type', plate_streak_type);

    queryParams = `?${params.toString()}`;
    const res = await axios.post(`${endpoints.program.set_plate_streak}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during save setting:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// BREAKDOWNS
export const get_food_breakdown = async (id, log, unit_id) => {
  try {
    const params = {
      id,
      ...(log?.id && {
        member_day_food_dish_id: log.id,
      }),
      ...(unit_id && {
        food_log_unit_id: unit_id,
      }),
    };

    const res = await axios.get(endpoints.program.get_food_breakdown, { params });

    return res;
  } catch (error) {
    console.error('Error getting breakdown:', error);
    throw error;
  }
};

export const get_dish_breakdown = async (id) => {
  try {
    const res = await axios.get(`${endpoints.program.get_dish_breakdown}?id=${id}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting breakdown:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// UPDATE TIME ZONE
export const update_time_zone = async (timezone_id) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    timezone_id && formData.append('timezone_id', timezone_id);

    const res = await axios.post(endpoints.program.update_time_zone, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error updating time zone', error);
    throw error;
  }
};

export const get_timezones = async (id) => {
  try {
    const res = await axios.get(`${endpoints.program.get_timezones}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting breakdown:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD EXERCISE TO LIBRARY
export const add_workout_to_library = async ({
  exercise_id,
  program_id,
  is_copy,
  custom_tab_id,
}) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    exercise_id && formData.append('exercise_id', exercise_id);
    program_id && formData.append('program_id', program_id);
    is_copy && formData.append('is_copy', is_copy);
    custom_tab_id &&
      custom_tab_id !== 'exercise_library' &&
      custom_tab_id !== 'nutrition_library' &&
      formData.append('custom_tab_id', custom_tab_id);

    const res = await axios.post(endpoints.program.add_exercise_to_library, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding exercise to library', error);
    throw error;
  }
};

export const check_exercise_duplicate = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('exercise_id', id);

    const res = await axios.post(endpoints.program.check_exercise_exists, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error checking duplication', error);
    throw error;
  }
};

export const check_program_duplicate = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('program_id', id);

    const res = await axios.post(endpoints.library.check_program_exist, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error checking duplication', error);
    throw error;
  }
};

// ADD PROGRAM TO LIBRARY
export const add_program_to_library = async ({ program_id, is_copy, custom_tab_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_id', program_id);
    is_copy && formData.append('is_copy', is_copy);
    custom_tab_id &&
      custom_tab_id !== 'exercise_library' &&
      custom_tab_id !== 'nutrition_library' &&
      formData.append('custom_tab_id', custom_tab_id);

    const res = await axios.post(endpoints.library.add_program_to_library, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding program to library', error);
    throw error;
  }
};

// ADD PLATE PROGRAM TO LIBRARY
export const add_plate_program_to_library = async ({ program_id, is_copy, custom_tab_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('program_id', program_id);
    is_copy && formData.append('is_copy', is_copy);
    custom_tab_id &&
      custom_tab_id !== 'exercise_library' &&
      custom_tab_id !== 'nutrition_library' &&
      formData.append('custom_tab_id', custom_tab_id);

    const res = await axios.post(endpoints.library.add_plate_program_to_library, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding program to library', error);
    throw error;
  }
};

// CHECK PLATE PROGRAM DUPLICATE
export const check_plate_program_duplicate = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('program_id', id);

    const res = await axios.post(endpoints.library.check_plate_program_exist, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error checking duplication', error);
    throw error;
  }
};
